/**
 * Format a Store API price integer. The API gives prices as integers in the
 * store's minor unit — 2 decimals means cents, but this store runs 0 decimals
 * ("$377"), so dividing by a fixed 100 is wrong. The currency fields travel on
 * every `totals` object (cart.totals and item.totals).
 */
export function money(amount, totals) {
	const minor = Number.isFinite(totals?.currency_minor_unit)
		? totals.currency_minor_unit
		: 2;
	const value = parseInt(amount, 10) / 10 ** minor;
	const prefix = totals?.currency_prefix ?? "$";
	const suffix = totals?.currency_suffix ?? "";
	return `${prefix}${value.toFixed(minor)}${suffix}`;
}

/** Sum a list of Store API integer strings. */
export function sumCents(list) {
	return list.reduce((sum, v) => sum + (parseInt(v, 10) || 0), 0);
}

/**
 * A cart line's total *including tax* — prices on this store are shown
 * tax-inclusive, matching how WooCommerce displays them everywhere else.
 */
export function lineTotalInc(item) {
	return (
		(parseInt(item.totals.line_total, 10) || 0) +
		(parseInt(item.totals.line_total_tax, 10) || 0)
	);
}
